export const FEATURE_FLAGS = {
  ENABLE_PX_SURVEY: 'OSTA.7263.Enable.PX.Survey',
};
